import React, {useState, useEffect, useContext} from 'react';
import { PassengerAPI } from '../../../../../../../API/PassengerAPIs/PassengerAPIs';
import {format} from 'date-fns';
import STCButton from '../../../../../../../STCLibrary/STCFactory/STCButton/STCButton';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';

export default function PaymentHistoryTableRow({passenger, handleOpenReceipt}){

  const navigate = useNavigate();
  const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState([]);

    const getPayments = () => {
        PassengerAPI.GetPaymentHistory(passenger.id)
        .then((response) => {
            if(response.status === 200){
                setPaymentData(response.data);
                setLoading(false)
            }
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
      }

      

    useEffect(() => {
        getPayments();
      }, [passenger]);

      if(loading){
        return(
            <tr>
              <td>{passenger.firstName} {passenger.surname}</td>
              <td>Loading...</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
          )
      }
      else{
      if(paymentData.length > 0){
        return paymentData.map((payment) => {
          return(
            <tr key={payment.id}>
              <td>{passenger.firstName} {passenger.surname}</td>
              <td>{payment.bookingId}</td>
              <td>{payment.amount}</td>
              <td>{format( new Date(payment.createdDate), 'dd-LLL-yyyy')}</td>
              {/* <td><STCButton onClick={() => handleOpenReceipt(payment)}>Receipt</STCButton></td> */}
            </tr>
          )
        })
      }
      else{
        // return null
        return(
          <tr>
            <td>{passenger.firstName} {passenger.surname}</td>
            <td>No payments made</td>
            <td>-</td>
            <td>-</td>
          </tr>
        )
      }
    }
}